var c = [
  {
    obj: {
      src: "ghost_0",
      side: 2,
      glowText: true,
      emissive: 16777215,
    },
    behaviour: 0,
    bobD: 1,
    bobS: 0.005,
    emissive: true,
    scale: 4,
  },
  {
    obj: {
      src: "ghost_0",
      side: 2,
      glowText: true,
      emissive: 16777215,
      noAutoAnim: true,
      frames: 2,
    },
    canShoot: true,
    visDis: 500,
    proj: 1,
    health: 300,
    score: 10,
    speed: 0.8,
    frate: 2500,
    turnSpd: 20,
    emissive: true,
    scale: 4,
  },
  {
    obj: {
      src: "pumpkin_0",
      glowText: true,
      emissive: 16777215,
    },
    noFram: true,
    canHit: true,
    rotY: true,
    visDis: 500,
    health: 700,
    score: 10,
    speed: 0.6,
    turnSpd: 4,
    emissive: true,
    scale: 4,
  },
];
function AI(f, g, h, j) {
  var k;
  var l = [];
  this.init = function (x, y, z, name, index, dat, sid) {
    this.isAI = true;
    this.sid = sid;
    var _posZ = z;
    var z = dat || c[index];
    this.dat = dat;
    this.index = index;
    this.active = true;
    this.name = name || "";
    this.assetID = (z.asset || "").replace(/[^\d]/g, "");
    this.reward = z.reward;
    this.maxHealth = z.health || 0;
    this.health = this.maxHealth;
    this.speed = (z.speed || 0) * 0.031;
    this.turnSpd = (z.turnSpd || 0) * 0.002;
    this.gravity = (z.grv || 0) * 0.1;
    this.killScore = z.score || 0;
    this.respawnT = z.respawnT || 0;
    this.respawnR = !!z.respawnR;
    this.breakAttack = 0;
    this.breakMove = 0;
    this.breakTimer = 0;
    this.canShoot = !!z.canShoot;
    this.projType = z.proj || 0;
    this.fireRate = z.frate || 2000;
    if (this.fireRate < 0) {
      this.fireRate = 200;
    }
    this.shootTimer = this.fireRate || 0;
    this.shotSprd = 0.02;
    this.shotOff = 2;
    this.specAtkTim = 0;
    this.specAtkTim2 = 0;
    this.usedSpecial = false;
    this.spawnMTim = 0;
    this.spawnCap = 20;
    this.canHit = !!z.canHit;
    this.hitRange = this.canShoot ? 40 : 10;
    this.hitDMG = 25;
    this.hitTimer = 0;
    this.hitRate = 800;
    this.bobD = z.bobD || 0.2;
    this.bobS = z.bobS || 0.004;
    this.bobVal = 0;
    this.scale = z.mSize || 4;
    this.x = (x || 0).round(1);
    this.y = (y || 0).round(1);
    this.z = (_posZ || 0).round(1);
    this.startP = {
      x: this.x,
      y: this.y,
      z: this.z,
    };
    this.xD = 0;
    this.yD = 0;
    this.rotY = z.rotY;
    this.behaviour = 1;
    this.behavType = z.behav || 0;
    this.actionFreq = 0;
    this.target = null;
    this.vision = z.visDis || 120;
    this.xray = !!z.xrayVis;
    this.canBSeen = false;
    this.sentTo = [];
    this.alwaysName = this.scale >= 6;
    this.frames = this.assetID ? 0 : 2;
    if (z.noFram) {
      this.frames = 0;
    }
    this.tFrame = 0;
    this.lastFrame = 0;
    this.frameRT = 0;
    if (g) {
      this.mesh = g.genObj3D(x, y, z);
      var A = this.assetID && dat ? this.assetID + "/" + dat.src : "ghost_0";
      this.meshRef = g.loadMesh(
        dat
          ? {
              side: 2,
              umid: this.scale > 4 ? this.sid : null,
              asset: !!this.assetID,
              noAutoAnim: true,
              frames: this.frames,
              emissive: A == "ghost_0" ? 16777215 : null,
              src: A,
            }
          : z.obj,
        0,
        this.scale,
        0,
        0,
        this.scale,
        this.mesh,
      );
      g.scene.add(this.mesh);
    }
    this.atkSound = z.atk || 0;
    this.deathSound = z.dth || 0;
    if (h) {
      this.idleSound = z.idl || 0;
      this.idlSoundI = 5000;
      this.idlSoundT = this.idlSoundI * j.randFloat(0.8, 1.2);
    }
    this.triggerAction = z.action;
    this.triggerConstant = z.constant;
    this.triggerChance = z.chance;
    this.triggerConstantTxt = z.constantTxt;
    this.triggerSound = [z.snd, z.vol, z.rate, z.emitfrom, z.assetSnd];
    this.triggerConstantEvent = z.constantEvent || 0;
    if (z.eventN) {
      this[z.eventN] = true;
    }
    this.interface = z.interface;
    this.interfaceT = z.interfaceT;
    this.singleUse = z.singleUse;
  };
  this.getData = function () {
    return [
      this.sid,
      this.index,
      this.name,
      this.x.round(1),
      this.y.round(1),
      this.z.round(1),
      this.dat
        ? {
            health: this.maxHealth,
            mSize: this.scale,
            asset: this.dat.asset || 0,
            idl: this.dat.idl,
            src: this.dat.src,
          }
        : 0,
    ];
  };
  this.emitSound = function (m, o, p, q, u) {
    f.playSound(
      m,
      (o || 1) * 0.9,
      0,
      Math.round(p || this.x),
      Math.round(q || this.y),
      Math.round(u || this.z),
      true,
      1,
      false,
      true,
      true,
    );
  };
  this.update = function (q) {
    if (g) {
      if (!this.active || !this.mesh || !this.mesh.visible) {
        return;
      }
      if (this.bobD && this.bobS) {
        this.bobVal += q * this.bobS;
      }
      this.mesh.position.x = this.x;
      this.mesh.position.y = this.y + Math.sin(this.bobVal) * this.bobD;
      this.mesh.position.z = this.z;
      this.mesh.rotation.y = this.xD;
      if (this.frames && this.frames > 1 && this.tFrame != this.lastFrame) {
        this.lastFrame = this.tFrame;
        if (this.meshRef && this.meshRef.material.map) {
          this.meshRef.material.map.offset.x =
            (this.tFrame % this.frames) / this.frames;
        }
      }
      if (this.idleSound) {
        this.idlSoundT -= q;
        if (this.idlSoundT <= 0) {
          this.idlSoundT = this.idlSoundI * j.randFloat(0.8, 1.2);
          f.playerSound(
            this.idleSound,
            0.2,
            this.x,
            this.y,
            this.z,
            1,
            1,
            false,
            true,
            true,
          );
        }
      }
    } else {
      if (this.behavior == 0) {
        return;
      }
      if (this.rspTimer) {
        this.rspTimer -= q;
        if (!(this.rspTimer <= 0)) {
          return;
        }
        this.active = true;
        this.target = null;
        this.x = this.startP.x;
        this.y = this.startP.y;
        this.z = this.startP.z;
        this.health = this.maxHealth;
        this.rspTimer = 0;
      }
      if (!this.active) {
        return;
      }
      if (this.breakMove > 0) {
        this.breakMove -= q;
        if (this.breakMove <= 0) {
          this.breakMove = 0;
        }
      }
      if (this.frameRT) {
        this.frameRT -= q;
        if (this.frameRT <= 0) {
          this.frameRT = 0;
          this.tFrame = 0;
        }
      }
      this.oldX = this.x;
      this.oldY = this.y;
      this.oldZ = this.z;
      this.y -= this.gravity * q;
      var z = 1;
      if (this.behavType == 1 && this.target) {
        this.breakTimer += q;
        if (this.breakTimer >= 5000) {
          this.breakTimer = -j.randInt(0, 5000);
          this.breakAttack = 4000;
        }
        if (
          this.health <= this.maxHealth / 1.5 &&
          ((z = 1.5), (this.specAtkTim -= q), this.specAtkTim <= 0)
        ) {
          this.specAtkTim = j.randInt(7000, 12000);
          this.breakMove = 2000;
          this.breakAttack = 3000;
          for (
            var A = 8, B = 0, D = f.projectiles.stored[1], E = 0;
            E < A;
            ++E
          ) {
            f.projectiles.init(
              this.x,
              this.y + this.shotOff,
              this.z,
              B,
              0,
              D,
              null,
              {},
              true,
              "orb_0",
            );
            B += (Math.PI * 2) / A;
          }
        }
        if (
          this.health <= this.maxHealth / 2 &&
          ((z = 2), (this.specAtkTim2 -= q), this.specAtkTim2 <= 0)
        ) {
          this.emitSound(3236);
          this.specAtkTim2 = j.randInt(12000, 16000);
          this.specAtkTim = 0;
          var F = j.randFloat(-Math.PI, Math.PI);
          this.x = this.startP.x + Math.cos(F) * 100;
          this.z = this.startP.z + Math.sin(F) * 100;
        }
      }
      if (this.behavType == 2 && this.target) {
        if (
          this.health <= this.maxHealth / 2 &&
          (this.shootTimer > 7000 && (this.shootTimer = 7000),
          !this.usedSpecial)
        ) {
          this.usedSpecial = true;
          var G = 0;
          for (E = 0; E < 6; ++E) {
            var H = this.scale * 2 + 70;
            var I = this.x + H * Math.cos(G);
            var J = this.y + this.scale * 2 + 10;
            var K = this.z + H * Math.sin(G);
            this.emitSound(3236, null, this.x, this.y, this.z);
            f.AI.spawn(null, 2, "Jack O' Lantern", I, J, K);
            G += (Math.PI * 2) / 6;
          }
        }
        this.specAtkTim -= q;
        if (this.specAtkTim <= 0) {
          this.specAtkTim = j.randInt(5000, 10000);
          this.breakAttack = 1000;
          A = 8;
          B = 0;
          D = f.projectiles.stored[1];
          E = 0;
          for (; E < A; ++E) {
            f.projectiles.init(
              this.x,
              this.y + 3 + this.scale + this.shotOff,
              this.z,
              B,
              0,
              D,
              null,
              {},
              true,
              "orb_0",
            );
            B += (Math.PI * 2) / A;
          }
        }
        if (
          this.spawnCap > 0 &&
          ((this.spawnMTim += q), this.spawnMTim >= 6000)
        ) {
          this.spawnCap--;
          this.spawnMTim = -j.randInt(0, 6000);
          var L = j.randFloat(-Math.PI, Math.PI);
          H = this.scale * 2 + 100;
          I = this.x + H * Math.cos(L);
          J = this.y + this.scale * 2 + 10;
          K = this.z + H * Math.sin(L);
          this.emitSound(3236, null, I, J, K);
          f.AI.spawn(null, 1, "Lost Soul", I, J, K);
        }
      }
      if (this.behaviour == 1) {
        this.actionFreq -= q;
        if (this.actionFreq <= 0) {
          this.target = f.players.findNearestTo(
            this.x,
            this.y + this.scale / 2,
            this.z,
            this.vision,
            this.xray,
          );
          this.actionFreq = this.target ? 2000 : 5000;
        }
        var N = Math.PI * 2;
        var O = this.target || this.startP;
        var P = (Y = j.getDrs(O, this))[0] + Math.PI / 2;
        var Q = Y[1];
        var R = (this.xD - P + N) % N;
        var U = Math.min(Math.abs(R - N), R, this.turnSpd * z * q);
        var V = R - Math.PI >= 0 ? 1 : -1;
        this.xD += V * U + N;
        R = (this.yD - Q + N) % N;
        U = Math.min(Math.abs(R - N), R, this.turnSpd * z * q);
        V = R - Math.PI >= 0 ? 1 : -1;
        this.yD += V * U + N;
        if (
          this.speed &&
          !this.breakMove &&
          j.getD3D(this.x, this.y, this.z, O.x, O.y, O.z) >= this.hitRange
        ) {
          var W = this.speed * z * q;
          this.x += W * Math.sin(this.xD + Math.PI / 2) * Math.cos(this.yD);
          this.z += W * Math.cos(this.xD + Math.PI / 2) * Math.cos(this.yD);
          this.y += W * Math.sin(this.yD);
        }
      }
      if (this.breakAttack > 0) {
        this.breakAttack -= q;
        if (this.breakAttack <= 0) {
          this.breakAttack = 0;
        }
      }
      if (
        !this.breakAttack &&
        this.canHit &&
        ((this.hitTimer -= q), this.hitTimer <= 0)
      ) {
        this.hitTimer = this.hitRate;
        var X = f.players.findNearestTo(
          this.x,
          this.y,
          this.z,
          this.hitRange,
          true,
        );
        if (X) {
          this.breakMove = 900;
          if (f.players.changeHealth(X, null, this.hitDMG)) {
            f.players.kill(X, null, {});
          }
        }
      }
      if (
        !this.breakAttack &&
        this.canShoot &&
        ((this.shootTimer -= q), this.target && this.shootTimer < 0)
      ) {
        this.shootTimer = this.fireRate;
        this.frameRT = 1000;
        this.tFrame = 1;
        var Y;
        P =
          (Y = j.getDrs(this.target, this))[0] +
          j.randFloat(-this.shotSprd, this.shotSprd);
        Q = Y[1] + j.randFloat(-this.shotSprd, this.shotSprd);
        if ((D = f.projectiles.stored[this.projType + 1])) {
          this.emitSound(this.atkSound);
          f.projectiles.init(
            this.x,
            this.y + this.scale / 2 + this.shotOff,
            this.z,
            P,
            Q,
            D,
            null,
            {},
            true,
            "orb_0",
          );
        }
      }
      if ((k = f.map.manager.getGridArrays(this.x, this.y, this.z))) {
        l.length = 0;
        for (E = 0; E < k.length; ++E) {
          tmpObj = k[E];
          if (!(l.indexOf(tmpObj.sid) >= 0)) {
            l.push(tmpObj.sid);
            if (tmpObj.active && this.collides(tmpObj)) {
              if (
                (this.y < tmpObj.y + tmpObj.height &&
                  tmpObj.y + tmpObj.height - this.y <= 3 &&
                  this.oldY < tmpObj.y + tmpObj.height) ||
                this.oldY >= tmpObj.y + tmpObj.height
              ) {
                this.y = tmpObj.y + tmpObj.height;
              } else if (
                this.oldX - this.scale >=
                tmpObj.x + tmpObj.width - 0.00001
              ) {
                this.x = tmpObj.x + tmpObj.width + this.scale;
              } else if (
                this.oldX + this.scale <=
                tmpObj.x - tmpObj.width + 0.00001
              ) {
                this.x = tmpObj.x - tmpObj.width - this.scale;
              } else if (
                this.oldZ - this.scale >=
                tmpObj.z + tmpObj.length - 0.00001
              ) {
                this.z = tmpObj.z + tmpObj.length + this.scale;
              } else if (
                this.oldZ + this.scale <=
                tmpObj.z - tmpObj.length + 0.00001
              ) {
                this.z = tmpObj.z - tmpObj.length - this.scale;
              }
            }
          }
        }
        k = null;
      }
    }
  };
  this.changeHealth = function (m, o, p) {
    if (this.health) {
      this.health += m;
      if (this.health <= 0) {
        this.kill(o);
      }
    }
    if (o) {
      o.dmgDealt -= m;
    }
    this.frameRT = 1000;
    this.tFrame = 1;
    if (o && this.behaviour == 1 && (p || !this.target)) {
      this.target = o;
      this.actionFreq = 5000;
    }
  };
  this.kill = function (m) {
    if (
      this.active &&
      ((this.active = false),
      (this.health = 0),
      this.deathSound && this.emitSound(this.deathSound),
      (this.rspTimer = this.respawnR
        ? j.randInt(100, this.respawnT || 5000)
        : this.respawnT || 0),
      this.onAIDeath && f.onTrigger(m, this),
      this.reward && !f.isCustom)
    ) {
      for (var o = 0; o < f.players.list.length; ++o) {
        if (f.players.list[o].active) {
          var p = f.getItemByChance(this.reward);
          if (p && p != -1) {
            f.giveSkin(f.players.list[o], p);
          }
        }
      }
    }
  };
  this.collides = function (m) {
    return (
      this.x - this.scale < m.x + m.width &&
      this.x + this.scale > m.x - m.width &&
      this.z - this.scale < m.z + m.length &&
      this.z + this.scale > m.z - m.length &&
      this.y <= m.y + m.height &&
      this.y + this.scale >= m.y - m.height
    );
  };
}
module.exports = function (f, g, h, j, k) {
  this.ais = [];
  var m;
  var q;
  var u;
  var v = [];
  var w = this;
  this.cSpawn = function (x) {
    w.spawn(x[0], x[1], x[2], x[3], x[4], x[5], x[6]);
  };
  this.spawn = function (x, y, z, A, B, C, D) {
    var E = new AI(f, g, h, j);
    x ||= j.generateSID(this.ais);
    E.init(A, B, C, z, y, D, x);
    this.ais.push(E);
  };
  this.update = function (x) {
    for (var y = 0; y < this.ais.length; ++y) {
      this.ais[y].update(x);
    }
    for (y = 0; y < this.ais.length; ++y) {
      if ((q = this.ais[y]).active && q.speed) {
        for (var z = y + 1; z < this.ais.length; ++z) {
          if ((u = this.ais[z]).active) {
            var A = j.getD3D(q.x, q.y, q.z, u.x, u.y, u.z);
            var B = q.scale + u.scale;
            if (A < B) {
              var C = j.direction2D(q.x, q.z, u.x, u.z);
              q.x = u.x + B * Math.cos(C);
              q.z = u.z + B * Math.sin(C);
            }
          }
        }
      }
    }
  };
  this.hideAll = function () {
    for (var x = 0; x < this.ais.length; ++x) {
      if (this.ais[x].mesh) {
        this.ais[x].mesh.visible = false;
      }
    }
  };
  this.findBySid = function (x) {
    for (var y = 0; y < this.ais.length; ++y) {
      if (this.ais[y].sid == x) {
        return this.ais[y];
      }
    }
    return null;
  };
  this.syncAll = function (x) {
    w.hideAll();
    if (x) {
      for (var y = 0; y < x.length; ) {
        if ((m = w.findBySid(x[y]))) {
          if (m.mesh) {
            m.mesh.visible = true;
          }
          m.x = x[y + 1] || 0;
          m.y = x[y + 2] || 0;
          m.z = x[y + 3] || 0;
          m.xD = x[y + 4] || 0;
          m.yD = x[y + 5] || 0;
          m.health = x[y + 6] || 0;
          m.tFrame = x[y + 7] || 0;
        }
        y += 8;
      }
    }
  };
  this.sync = function () {
    if (this.ais.length) {
      for (var x = 0; x < f.players.list.length; ++x) {
        if ((q = f.players.list[x]).active || q.spectating) {
          v.length = 0;
          for (var y = 0; y < this.ais.length; ++y) {
            if (
              (u = this.ais[y]).active &&
              (q.spectating || !(j.getD3D(q.x, q.y, q.z, u.x, u.y, u.z) > 600))
            ) {
              if (u.sentTo.indexOf(q.id) >= 0) {
                v.push(
                  u.sid,
                  u.x.round(1),
                  u.y.round(1),
                  u.z.round(1),
                  u.xD.round(2),
                  u.yD.round(2),
                  Math.floor(u.health),
                  u.tFrame,
                );
              } else {
                u.sentTo.push(q.id);
                k.send(q.id, "aai", u.getData());
              }
            }
          }
          k.send(q.id, "ai", v.length ? v : 0);
        }
      }
    }
  };
  this.remove = function (x, y) {
    if (g && x.mesh) {
      g.scene.remove(x.mesh);
      x.mesh = null;
    }
    x.active = false;
  };
  this.reset = function () {
    for (var x = 0; x < this.ais.length; ++x) {
      this.remove(this.ais[x]);
    }
    this.ais.length = 0;
  };
};
